import { React, useContext, useState } from "react";
import { AppContext } from "../../context/AppContext";
import Form from "react-bootstrap/Form";
import DDlogo from "../../assets/images/DDlogo.png";
import whiteTrash from "../../assets/images/whiteTrash.svg";
import whiteHand from "../../assets/images/whiteHand.svg";
import whiteBox from "../../assets/images/whiteBox.svg";
import whiteBin from "../../assets/images/whiteBin.svg";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import MapComponent from "../../sharedComponent/MapComponent";
import { useTranslation } from "react-i18next";

const EditGeofenceArea = () => {
  const { sidebar, setSidebar, Dark, setDark } = useContext(AppContext);
  const [validated, setValidated] = useState(false);
  const { t, i18n } = useTranslation();

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };
  const aninations = {
    initial: { opacity: 0, x: 400 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };
  const renderTooltipForPoligon = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Draw Polygon
    </Tooltip>
  );
  const renderTooltipForRectangle = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Draw Rectangle
    </Tooltip>
  );
  const renderTooltipForPalm = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Move
    </Tooltip>
  );
  const renderTooltipForDelet = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Delete
    </Tooltip>
  );
  return (
    <>
      <motion.div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
        variants={aninations}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1 }}
      >
        <div id="cx-wrapper" className="AddGeofenceArea">
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="main-master-wrapper">
              <div className="Heading">
                <p>{t("Edit Geofence")}</p>
              </div>
              <div className="innerInputsGen">
                <div className="row">
                  <div className="col-md-6 form_input_main ">
                    <div className="innerSelectBox weekCounter">
                      <Form.Label className="common-labels">
                        {t("Parent Area")}
                      </Form.Label>
                      <Form.Select
                        required
                        as="select"
                        type="select"
                        name="Speed_limit"
                      >
                        <option value="">Select Area...</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="150">150</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Select Area
                      </Form.Control.Feedback>
                    </div>
                  </div>
                  <div className="col-md-6 form_input_main ">
                    <div className="innerSelectBox weekCounter">
                      <Form.Label className="common-labels">
                        {t("Geofence Areas")} <span>&#42;</span>
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        placeholder="Enter Location Address"
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Geofence Areas
                      </Form.Control.Feedback>
                    </div>
                  </div>
                  <div className="col-md-6 form_input_main ">
                    <div className="innerSelectBox weekCounter">
                      <Form.Label className="common-labels">
                        {t("Address")} <span>&#42;</span>
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        placeholder="Enter  Address"
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Geofence Address
                      </Form.Control.Feedback>
                    </div>
                  </div>
                  <div className="col-md-6 form_input_main ">
                    <div className="innerSelectBox weekCounter">
                      <Form.Label className="common-labels">{t("Landmark")}</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        placeholder="Enter Landmark ..."
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Landmark
                      </Form.Control.Feedback>
                    </div>
                  </div>
                  <div className="col-md-6 form_input_main ">
                    <div className="innerSelectBox weekCounter">
                      <Form.Label className="common-labels">
                        {t("City / State")} <span>&#42;</span>
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        placeholder="Enter City / State..."
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter City / State...
                      </Form.Control.Feedback>
                    </div>
                  </div>
                  <div className="col-md-6 form_input_main ">
                    <div className="innerSelectBox weekCounter">
                      <Form.Label className="common-labels">{t("Country")}</Form.Label>
                      <Form.Select
                        required
                        as="select"
                        type="select"
                        name="Speed_limit"
                      >
                        <option value="">Select Country...</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="150">150</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Select Country
                      </Form.Control.Feedback>
                    </div>
                  </div>
                  <div className="col-md-6 form_input_main ">
                    <div className="innerSelectBox weekCounter">
                      <Form.Label className="common-labels">
                        {t("Area Speed Limit")} <span>&#42;</span>
                      </Form.Label>
                      <Form.Select
                        required
                        as="select"
                        type="select"
                        name="Speed_limit"
                      >
                        <option value="">Select Speed Limit...</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="150">150</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Select Speed Limit
                      </Form.Control.Feedback>
                    </div>
                  </div>
                  <div className="col-md-12 weekCounter mb-4">
                    <div className="addParkingMap">
                      <MapComponent />
                      
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end align-items-center btn-wrapper">
                  <button className="cx-btn-1">{t("Cancel")}</button>
                  <button className="cx-btn-2">{t("Submit")}</button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </motion.div>
    </>
  );
};

export default EditGeofenceArea;
